export default [
  {
    id: '1',
    parentId: '0',
    title: '工作台',
    path: '/brands/work',
    type: 2,
    component: '/brands/work/work',
    isHidden: false,
    icon: 'kl-work'
  }
]
